import React from 'react'
import styled from 'styled-components';
import { THEME } from '../../genericComponents/globalStyles';
import { Modal } from 'antd';
import {useTranslation} from 'react-i18next'; 
import { RowTypeSpaceBetween } from '../../genericComponents/Layouts';
import Text from '../../genericComponents/Text';
import { CloseOutlined } from '@ant-design/icons';


export default function EquipmentListModal({isModalVisible,setIsModalVisible,speaker,amplifier,showAmplifier}){
  const { t } = useTranslation();
  return (
    <ModalContentTotal
      visible={isModalVisible} 
      width={1000}
      footer={null}
      closeIcon={<CloseOutlined style={{color:'#FFF'}}/>}
      onCancel={()=>setIsModalVisible(false)}
    >
      <ModalHeader>{t('equipment_list')}</ModalHeader>
        <RowTypeSpaceBetween style={{padding:'16px 0'}}>
          <div/>
          <div style={{textAlign:'center'}}>
            <Text titleSize={1} titleLevel={4}>{t('total_number_of_speakers')}</Text>
            <Text titleSize={3} titleLevel={4} strong>{speaker?.quantity}</Text>
          </div>
          <div style={{textAlign:'center'}}>
            <Text titleSize={1} titleLevel={4}>{t('speaker_model')}</Text>
            <Text titleSize={3} titleLevel={4} strong>{speaker?.name}</Text>
          </div>
          {showAmplifier&&amplifier.name&&
            <>
              <Divider/>
              <div style={{textAlign:'center',}}>
                <Text titleSize={1} titleLevel={4}>{t('total_number_of_amplifiers')}</Text>
                <Text titleSize={3} titleLevel={4} strong>{amplifier?.quantity}</Text>
              </div>
              <div style={{textAlign:'center'}}>
                <Text titleSize={1} titleLevel={4}>{t('amplifier_model')}</Text>
                <Text titleSize={3} titleLevel={4} strong>{amplifier?.name}</Text>
              </div>
            </>
          }
          <div/>
        </RowTypeSpaceBetween>
    </ModalContentTotal>
  )
}

const ModalContentTotal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    border-radius: 12px;
  }
`;
const ModalHeader = styled.div`
  width: 100%;
  padding: 12px;
  text-align: center;
  font-size: 1.2em;;
  background-color: ${THEME.colors.blue};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  color: #FFF;
`;
const Divider = styled.div`
  width: 1px;
  height: 60px;
  background: #CCC;

`;